/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { AppConfig } from "@nf/constants";
import { httpService } from "../../../../services";
import { HTTP_METHOD } from "@nf/constants";
import { IConfigModel, IComponentConfigModel } from "../models";

export class ClientConfigService {
  get url(): string {
    return "/v2";
  }

  public getConfiguration = (): Promise<IConfigModel> =>
    httpService.request<IConfigModel>({
      axiosConfig: {
        timeout: 60000,
        headers: {
          Authorization: "",
        },
      },
      method: HTTP_METHOD.GET,
      url: `${this.url}/config/${AppConfig.ConfigId}`,
    });

  public getComponent = (referenceId: string): Promise<IComponentConfigModel> =>
    httpService.request<IComponentConfigModel>({
      axiosConfig: {
        timeout: 10000,
        headers: {
          Authorization: "",
        },
      },
      method: HTTP_METHOD.GET,
      url: `${this.url}/config/${AppConfig.ConfigId}/component/${referenceId}`,
    });

  public getComponentByUrl = (
    referenceUrl: string
  ): Promise<IComponentConfigModel> =>
    httpService.request<IComponentConfigModel>({
      axiosConfig: {
        headers: {
          Authorization: "",
        },
      },
      method: HTTP_METHOD.GET,
      url: referenceUrl,
    });
}
